var _path, _defs;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgBrandSmile = function SvgBrandSmile(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 122,
    height: 41,
    viewBox: "0 0 122 41",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M120.983 8.58556C121.983 9.09323 122.299 10.2355 121.69 11.1036C109.122 29.0496 86.6414 41 61 41C35.3586 41 12.8778 29.0496 0.310005 11.1087C-0.299136 10.2406 0.0169274 9.10338 1.01684 8.59064L17.4866 0.188788C18.2279 -0.191962 19.1761 0.0263341 19.6243 0.665992C28.2098 12.8703 43.5303 20.998 60.9943 20.998C78.4582 20.998 93.7844 12.8753 102.37 0.665992C102.824 0.0212574 103.766 -0.191962 104.508 0.188788L120.977 8.59064L120.983 8.58556Z",
    fill: "url(#paint0_linear_19581_84074)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_19581_84074",
    x1: 0,
    y1: 23.586,
    x2: 122,
    y2: 23.586,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D6B392"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AC875A"
  })))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgBrandSmile);
export default ForwardRef;